import { Component, ElementRef, inject, Input, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { ChangeLeftMenuVisibilityInput, ConfigurationServiceProxy } from "@shared/api/service-proxies";
import { MatIconModule } from "@angular/material/icon";
import { AppSessionService } from "@shared/session/app-session.service";
import { FuseNavigationModule } from "@fuse/components";
import { FuseDirectivesModule } from "@fuse/directives/directives";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "v2-navbar",
    templateUrl: "./v2-navbar.component.html",
    styleUrls: ["./v2-navbar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, FuseNavigationModule, FuseDirectivesModule],
})
export class V2NavbarComponent implements OnInit {
    // Private
    _variant: string;

    _sessionService = inject(AppSessionService);

    tenantName: string;

    /**
     * Constructor
     *
     * @param {ElementRef} _elementRef
     * @param {Renderer2} _renderer
     */
    constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {
        // Set the private defaults
        this._variant = "vertical-style-1";
    }

    ngOnInit(): void {
        if (this._sessionService.tenant !== undefined) {
            this.tenantName = this._sessionService.tenant.name;
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string {
        return this._variant;
    }

    @Input()
    set variant(value: string) {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
}
